import { FlowOutputStep } from '../types/FlowOutputStep';
import { FlowOutputStepRun } from '../types/FlowOutputStepRun';
import { FlowRun } from '../types/FlowRun';
import { IDataConnection } from '../types/IDataConnection';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IProject } from '../types/IProject';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { ISiteNameWithId } from '../types/ISiteNameWithId';
import { INamedItem } from '../types/resourceParts';
import { RunFlowTask } from '../types/RunFlowTask';
import { Request } from './Request';

export type GetRunFlowTasksParams = IGetItemsParams;

export type GetRunFlowTasksResult = IGetItemsResult & {
  readonly tasks: ReadonlyArray<RunFlowTask>;
  readonly flows: ReadonlyArray<INamedItem>;
  readonly schedules: ReadonlyArray<ISchedule>;
  readonly sites: ReadonlyArray<ISiteNameWithId>;
  readonly flowOutputSteps: ReadonlyArray<FlowOutputStep>;
  readonly flowRuns: ReadonlyArray<FlowRun>;
  readonly flowOutputStepRuns: ReadonlyArray<FlowOutputStepRun>;
  readonly dataConnections: ReadonlyArray<IDataConnection>;
};

export class GetRunFlowTasksRequest extends Request<GetRunFlowTasksParams, GetRunFlowTasksResult> {
  constructor(params: GetRunFlowTasksParams) {
    super('getRunFlowTasks', params);
  }
}
